import React from 'react';
import classnames from 'classnames';
import TRANSLATIONS from '../../../translations/translations@default.json';

const ProductDataSheet = ({ ProductDatasheetPdfUrl, is2020Label, CustomCategoriesEnabled }) => {  

	if (!ProductDatasheetPdfUrl) {
		return null;
	}
	
	return (
		<a
			href={ProductDatasheetPdfUrl}
			alt="product data sheet"
			target="_blank"
			rel="noopener noreferrer"
			data-tag-name="product-data-sheet-clicked"
			className={classnames('font-bold block text-body-xs text-link z-10 ml-0', 
      {
        'ml-1': is2020Label && CustomCategoriesEnabled,
        'ml-5': !is2020Label && CustomCategoriesEnabled,
        'z-10': CustomCategoriesEnabled,
        'ml-0': !CustomCategoriesEnabled,
      })}>
			{TRANSLATIONS.productList.productCard.energyLabel.productDataSheet}
		</a>
	);
};

export default ProductDataSheet;